import { dynamicFailed } from "../hooks/useToast";
import { IGeneralSettings, INotificationSettings, ISecuritySettings } from "../exports/interfaces";
import axiosClient from "../axioxClient.ts/axiosClient";

export const fetchGeneralSettings = async (): Promise<IGeneralSettings | null> => {
  try {
    const response = await axiosClient.get<IGeneralSettings[]>("/settings/general");
    return response.data?.[0] ?? null;
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
    return null;
  }
};

export const createGeneralSettings = async (payload: FormData) => {
  try {
    return await axiosClient.post<IGeneralSettings>("/settings/general", payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
    throw error;
  }
};

export const updateGeneralSettings = async (id: number, payload: FormData) => {
  try {
    return await axiosClient.put<IGeneralSettings>(`/settings/general/${id}`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
    throw error;
  }
};

export const fetchNotificationSettings = async (): Promise<INotificationSettings | null> => {
  try {
    const response = await axiosClient.get<INotificationSettings[]>("/settings/notifications");
    return response.data?.[0] ?? null;
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
    return null;
  }
};

export const createNotificationSettings = async (payload: INotificationSettings) => {
  try {
    return await axiosClient.post<INotificationSettings>("/settings/notifications", payload);
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
    throw error;
  }
};

export const updateNotificationSettings = async (
  id: number,
  payload: INotificationSettings,
) => {
  try {
    return await axiosClient.put<INotificationSettings>(`/settings/notifications/${id}`, payload);
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
    throw error;
  }
};

export const fetchSecuritySettings = async (): Promise<ISecuritySettings | null> => {
  try {
    const response = await axiosClient.get<ISecuritySettings[]>("/settings/security");
    return response.data?.[0] ?? null;
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
    return null;
  }
};

export const createSecuritySettings = async (payload: ISecuritySettings) => {
  try {
    return await axiosClient.post<ISecuritySettings>("/settings/security", payload);
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
    throw error;
  }
};

export const updateSecuritySettings = async (
  id: number,
  payload: ISecuritySettings,
) => {
  try {
    return await axiosClient.put<ISecuritySettings>(`/settings/security/${id}`, payload);
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
    throw error;
  }
};
